<template>
  <header class="z-30 w-full px-2 py-4 bg-white sm:px-4">
    <div class="flex items-center justify-between mx-auto max-w-7xl">

    </div>
  </header>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      open: false,
    };
  },
});
</script>
